module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_MT-3d6cb9ce3a3aeaaff759f9ea65c9f4de.svg";